import React, { useCallback, useState } from 'react';
import { ReactComponent as RightIcon } from './chevron_right-24px.svg';
import { ReactComponent as LeftIcon } from './chevron_left-24px.svg';
import styles from './Pagination.module.scss';
import { map, range } from 'lodash';
import PropTypes from 'prop-types';

function PaginationNew({
  hidePerPage,
  hideInfo,
  totalElements,
  number,
  totalPages,
  size,
  onChange,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const pageArray = range(0, totalPages);

  const onChangeSize = useCallback(
    async (value) => {
      setIsLoading(true);
      try {
        await onChange({ page: 0, size: value });
      } finally {
        setIsLoading(false);
      }
    },
    [number, size, onChange],
  );

  const onChangePage = useCallback(
    async (value) => {
      setIsLoading(true);
      try {
        await onChange({ page: value, size });
      } finally {
        setIsLoading(false);
      }
    },
    [number, size, onChange],
  );

  return totalPages > 1 ? (
    <div className={`d-flex align-items-center justify-content-end ${isLoading ? 'disabled' : ''}`}>
      {!hidePerPage && (
        <div className="align-items-center d-none d-sm-flex text-nowrap">
          <span>Количество на страницу</span>
          <select
            onChange={(e) => onChangeSize(+e.target.value)}
            value={size}
            name="select"
            className="border-0 m-2 bg-transparent"
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>
        </div>
      )}

      <div className="pl-4 pl-md-4p0 align-items-center d-none d-sm-flex">
        <span>Страница</span>
        <select
          className="border-0 m-2 bg-transparent"
          value={number}
          onChange={(e) => onChangePage(+e.target.value)}
          name="select"
        >
          {map(pageArray, (page) => {
            return (
              <option key={page} value={page}>
                {page + 1}
              </option>
            );
          })}
        </select>
      </div>
      {!hideInfo && size && (
        <div className="pl-4 pl-md-4p0 align-items-center text-nowrap">
          {1 + number * size}-
          {(number + 1) * size > totalElements ? totalElements : (number + 1) * size} из{' '}
          {totalElements}
        </div>
      )}
      <div className={`d-flex pl-4 pl-md-4p0 align-items-center text-nowrap ${styles.controls}`}>
        <LeftIcon
          className={number === 0 ? styles.controlsDisabled : ''}
          onClick={() => onChangePage(number - 1)}
          role="button"
        />
        <RightIcon
          className={number === totalPages - 1 ? styles.controlsDisabled : ''}
          onClick={() => onChangePage(number + 1)}
        />
      </div>
    </div>
  ) : null;
}

export default PaginationNew;

PaginationNew.propTypes = {
  number: PropTypes.any,
  onChange: PropTypes.any,
  size: PropTypes.any,
  totalElements: PropTypes.any,
  totalPages: PropTypes.any,
  hidePerPage: PropTypes.bool,
  hideInfo: PropTypes.bool,
};
